import { useCallback, useEffect, useState } from 'react';
import { LOG_ACTIONS, logAction, useLogAmplitude } from '@namespace/analytics';
import { useConfig, useGeneralRoutes, useOtherSettings } from '@namespace/cms';
import { clearRedirectAction, useReferenceState } from '@namespace/common';
import {
  getSessionStorageValue,
  SESSION_STORAGE_KEYS
} from '@namespace/helpers';
import { useI18n } from '@namespace/i18n';
import { useHistory } from '@namespace/router';
import GuestContent from '../../common/GuestContent';
import { BonusNotification } from './components/BonusNotification';
import { registerStepsMap } from './components/StepForm';

const Register = ({
  id,
  isWithCloseButtonWrapper = false,
  componentsMap = {},
  classNames = {},
  onClose,
  isPageInPopup = false
}) => {
  const { t } = useI18n();
  const { config = {} } = useConfig(id);
  const { steps = [], isNewHeaderGuestSections = false } = config;
  const { registrationBonusPopup = {} } = useOtherSettings();
  const { isEnabled: isRegistrationBonusPopupEnabled = false } =
    registrationBonusPopup;
  const [isDisplayBonusPopup, setIsDisplayBonusPopup] = useState(false);
  const [activeStep, setActiveStep] = useState(1);
  const [popup, setPopup] = useState({
    isShowPopup: false,
    secondClick: false
  });
  const { home } = useGeneralRoutes();
  const { push } = useHistory();
  const logAmplitude = useLogAmplitude();

  const onCloseHandler = useCallback(() => {
    const isBonusPopupShowed = getSessionStorageValue(
      SESSION_STORAGE_KEYS.IS_REGISTRATION_BONUS_POPUP_SHOWED,
      ''
    );

    if (isRegistrationBonusPopupEnabled && !isBonusPopupShowed) {
      setIsDisplayBonusPopup(true);
      return;
    }

    const redirectURL = clearRedirectAction();

    logAmplitude({ actionName: LOG_ACTIONS.REGISTRATION_CLICK_CLOSE });

    if (onClose && typeof onClose === 'function') {
      onClose();
    } else if (steps.length === activeStep) {
      push(redirectURL || home);
    } else {
      push(home);
    }
  }, [
    isRegistrationBonusPopupEnabled,
    logAmplitude,
    onClose,
    steps,
    activeStep,
    push,
    home
  ]);

  const onChangeStep = (step) => {
    setActiveStep(step);
  };

  const registerComponentsMap = {
    ...registerStepsMap,
    ...componentsMap
  };

  useReferenceState();

  useEffect(() => logAction(LOG_ACTIONS.REGISTRATION_PAGE_OPEN), []);

  return (
    <>
      {isDisplayBonusPopup && (
        <BonusNotification
          onContinue={() => setIsDisplayBonusPopup(false)}
          onClose={onCloseHandler}
        />
      )}
      <GuestContent
        config={{
          ...config,
          isWithCloseButtonWrapper
        }}
        {...(isNewHeaderGuestSections ? { header: t('register.title') } : {})}
        dataRole="register-page"
        classNames={classNames}
        onClose={onCloseHandler}
        popup={popup}
        setPopup={setPopup}
        onChangeStep={onChangeStep}
        componentsMap={registerComponentsMap}
        isPageInPopup={isPageInPopup}
      />
    </>
  );
};

export default Register;
